module.exports = __webpack_public_path__ + "img/icon-similar-light-blue.45a9c867.svg";